module.exports = __webpack_public_path__ + "img/page-banner-bg.527de2ef.png";